// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutWrapperSideNav_root__2YHjv","tabs":"LayoutWrapperSideNav_tabs__1k8Of","tab":"LayoutWrapperSideNav_tab__2VMY6"};